(() => {
  function setup(root) {
    root.querySelectorAll('[data-cft-product]').forEach(section => {
      if (section.dataset.cftReady) return;
      section.dataset.cftReady = 'true';
      section.querySelectorAll('[data-cft-gallery-src]').forEach(button => {
        button.addEventListener('click', () => {
          const picture = section.querySelector('[data-cft-gallery-image] picture');
          picture.querySelectorAll('source').forEach(source => source.remove());
          const image = picture.querySelector('img');
          image.removeAttribute('srcset');
          image.src = button.dataset.cftGallerySrc;
          image.alt = button.dataset.cftGalleryAlt;
          section.querySelectorAll('[data-cft-gallery-src]').forEach(peer => {
            peer.setAttribute('aria-pressed', String(peer === button));
          });
        });
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
